import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/services/clinical-solutions")({
  head: () => buildRouteHead("/services/clinical-solutions", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/services/clinical-solutions", replace: true });
  },
});
